export default {"src":"/_next/static/media/arrow-right-black.e587c6cf.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};